import React from 'react'
import { splitLunchServerTips } from '../actions'
import { useDispatch } from 'react-redux';

const SplitLunchTipsButton = () => {
    const dispatch = useDispatch();
 return <button onClick={() => dispatch(splitLunchServerTips())}>Split Lunch Tips</button>
 }

export default SplitLunchTipsButton